/* eslint-disable */
export const D360_LOAD_PROJECT_START = 'D360_LOAD_PROJECT_START';
export const D360_LOAD_PROJECT_SUCCESS = 'D360_LOAD_PROJECT_SUCCESS';
export const D360_LOAD_PROJECT_FAIL = 'D360_LOAD_PROJECT_FAIL';
